import { h } from 'preact'
import devtools from 'unistore/devtools'
import createStore from 'unistore'
import persistStore from 'unissist'
import localStorageAdapter from 'unissist/integrations/localStorageAdapter'
import { connect as unistoreConnect } from 'unistore/preact'

import actions from './actions'

export const initialState = {
  auth: { accessToken: null, email: null, expiration: null, refreshToken: null },
  me: { email: null, username: null },
}

const store =
  process.env.NODE_ENV === 'production'
    ? createStore(initialState)
    : devtools(createStore(initialState))

const adapter = localStorageAdapter()

persistStore(store, adapter)

export default store

export function connect(state, component) {
  return unistoreConnect(state, actions)(store => h(component, { ...store }))
}



// WEBPACK FOOTER //
// ./store/index.js